import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import * as Moment from 'moment';

import { Paper, Typography, LinearProgress } from '@material-ui/core';
import { ResponsiveContainer, Tooltip, BarChart, XAxis, Legend, Bar, YAxis } from 'recharts';
import { NumberLessBRL, MoneyLessBRL, MoneyFullBRL } from '../../../../services';
import { QUERY_FILTER_PUBLISHER, QueryFilter } from 'src/component/shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedPublisher } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IPublisherMonthComparativeProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherMonthComparativeState {
    customFilter: {
        isChart: boolean
    },

}
export interface IPublisherMonthComparativeDataChart {
    avg_price: number;
    billing: number;
    date: string;
    qtd_coupon: number;
    qtd_item_coupon: number;
    volume: number;
    year_actual: string;
    year_date: string;
    year_billing: number;
    year_billing_label: string;
    year_volume: number;
    year_avg_price: string;
    first_year: string;
    first_year_date: string;
    first_year_billing: number;
    first_year_billing_label: string;
    first_year_volume: number;
    first_year_avg_price: string;
    last_year: string;
    last_year_date: string;
    last_year_billing: number;
    last_year_billing_label: string;
    last_year_volume: number;
    last_year_avg_price: string;
}

const PUBLISHER_MONTH_COMPARATIVE = gql`
query publisherMonthComparative($customFilter:  PublisherCustomFilter) {
    publisherMonthComparative(publisherCustomFilter: $customFilter) {
        avg_price,
        avg_ticket,
        billing,
        date,
        qtd_coupon,
        qtd_item_coupon,
        volume,
        year_actual,
        year_date,
        year_billing,
        year_volume,
        year_avg_price,
        year_qtd_coupon,
        year_avg_ticket,
        year_qtd_item_coupon,
        last_year,
        last_year_date,
        last_year_billing,
        last_year_volume,
        last_year_avg_price,
        last_year_qtd_coupon,
        last_year_avg_ticket,
        last_year_qtd_item_coupon,
        first_year,
        first_year_date,
        first_year_billing,
        first_year_volume,
        first_year_avg_price,
        first_year_qtd_coupon,
        first_year_avg_ticket,
        first_year_qtd_item_coupon,
  }
}
`;

// statless component
const PublisherMonthComparativeData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (<div className="tooltip-box">
        <table>
            <tbody>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Ano</td>
                    <td className="tooltip-title"> {content && content.first_year} </td>
                    
                    <td className="tooltip-title">Ano</td>
                    <td className="tooltip-title"> {content && content.last_year} </td>
                    
                    <td className="tooltip-title" style={content && content.year_actual ? {} : { display: 'none' }}>Ano</td>
                    <td className="tooltip-title" style={content && content.year_actual ? {} : { display: 'none' }}>{content && content.year_actual} </td>

                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Faturamento:</td>
                    <td className="tooltip-content">{content && content.first_year_billing_label}</td>
                    
                    <td className="tooltip-title">Faturamento:</td>
                    <td className="tooltip-content">{content && content.last_year_billing_label}</td>
                    
                    <td className="tooltip-title" style={content && content.year_actual ? {} : { display: 'none' }}>Faturamento:</td>
                    <td className="tooltip-content" style={content && content.year_actual ? {} : { display: 'none' }}>{content && content.year_billing_label}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Preço Médio:</td>
                    <td className="tooltip-content">{content && content.first_year_avg_price}</td>

                    <td className="tooltip-title">Preço Médio:</td>
                    <td className="tooltip-content">{content && content.last_year_avg_price}</td>
                    
                    <td className="tooltip-title" style={content && content.year_actual ? {} : { display: 'none' }}>Preço Médio:</td>
                    <td className="tooltip-content" style={content && content.year_actual ? {} : { display: 'none' }}>{content && content.year_avg_price}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Volume:</td>
                    <td className="tooltip-content">{content && content.first_year_volume}</td>

                    <td className="tooltip-title">Volume:</td>
                    <td className="tooltip-content">{content && content.last_year_volume}</td>
                    
                    <td className="tooltip-title" style={content && content.year_actual ? {} : { display: 'none' }}>Volume:</td>
                    <td className="tooltip-content" style={content && content.year_actual ? {} : { display: 'none' }}>{content && content.year_volume}</td>
                </tr>
            </tbody>
        </table>
    </div>
    )
};
// statless component
const PublisherMonthComparativeChart = ({ data }: { data: IPublisherMonthComparativeDataChart[] }) => (
    <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 30, right: 25, left: 0, bottom: 15 }}>
            <Tooltip content={<PublisherMonthComparativeData isAnimationActive={false}  />} />
            <XAxis dataKey="date"/>
            <YAxis  yAxisId="only" hide={true} />
            <Legend />
            <Bar yAxisId="only" dataKey="first_year_billing" name="Há dois anos" fill="#65cc93" />
            <Bar yAxisId="only" dataKey="last_year_billing" name="Ano anterior" fill="#323232" />
            <Bar yAxisId="only" dataKey="year_billing" name="Ano atual" fill="#FF6A14" />

        </BarChart>
    </ResponsiveContainer>
);

const dataFilled = (data: any) => {
    return data && data.publisherMonthComparative && !!data.publisherMonthComparative.length
}

export class PublisherMonthComparative extends React.Component<IPublisherMonthComparativeProps, IPublisherMonthComparativeState> {
    constructor(props: IPublisherMonthComparativeProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
    }
}
    public render() {
        const jsonFilter = {
          "customFilter": {
            "isChart": this.state.customFilter.isChart,
          }
        };

        return (
            <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                    let dataCache = GetCacheIfExists('publisher-data');
                    const hasNoFilterAppliedPublisher = HasNoFilterAppliedPublisher(clientC);
    
                    if( hasNoFilterAppliedPublisher && dataCache != null && dataCache.publisherMonthComparative != null ) {
                        return this.dataToRend(dataCache, false);
                    } else {
                        return (
                            <Query query={PUBLISHER_MONTH_COMPARATIVE} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, ['endDate', 'initialDate'])}>
                                {({ loading, error, data, client}) => {

                                    if ( hasNoFilterAppliedPublisher && data != null && data.publisherMonthComparative != null ) {
                                        if(dataCache != null && dataCache !== undefined) {
                                            dataCache.publisherMonthComparative = data.publisherMonthComparative;
                                        } else {
                                            dataCache = data;
                                        }
                                        SetDataToSession('publisher-data', dataCache);
                                    }
                                    return this.dataToRend(data,loading);
                                }}
                            </Query>
                        );
                    }
                }}
            </Query>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        if(data != null && data !== undefined) {
            return  (
                <Paper className="publisher-sale-block panel-block">
                    <Typography variant="headline" className="panel-title" component="title">
                        Comparativo por Mês - Ano Atual x Ano Anterior
                    </Typography>
                    {
                        loading
                        ?
                        <LinearProgress />
                        :
                        (
                            dataFilled(data)
                            ?
                            (<PublisherMonthComparativeChart data={this.PublisherMonthComparativeMap(data.publisherMonthComparative)} />)
                            :
                            (<Typography variant="body2" className="comparative" component="p">
                                Não há informações de vendas
                            </Typography>)
                        )
                    }
                </Paper>
            )
        } else {
            return null;
        }
    }

    private PublisherMonthComparativeMap = (data: IPublisherMonthComparativeDataChart[]) => {

        const mappedData: IPublisherMonthComparativeDataChart[] = [];

        data.forEach(e => {
            const item: IPublisherMonthComparativeDataChart = {
                avg_price: e.avg_price,
                billing: Number(MoneyLessBRL(e.billing.toString())),
                date: e.date,

                first_year: e.first_year,
                first_year_avg_price: MoneyFullBRL(e.first_year_avg_price.toString()),
                first_year_billing:  Number.parseFloat(e.first_year_billing.toString()),
                first_year_billing_label: MoneyLessBRL(e.first_year_billing.toString()),
                first_year_date: Moment(e.first_year_date).format('MM/YYYY'),
                first_year_volume:  Number(NumberLessBRL(e.first_year_volume.toString())),

                last_year: e.last_year,
                last_year_avg_price: MoneyFullBRL(e.last_year_avg_price.toString()),
                last_year_billing:  Number.parseFloat(e.last_year_billing.toString()),
                last_year_billing_label: MoneyLessBRL(e.last_year_billing.toString()),
                last_year_date: Moment(e.last_year_date).format('MM/YYYY'),
                last_year_volume:  Number(NumberLessBRL(e.last_year_volume.toString())),
                
                qtd_coupon: Number(NumberLessBRL(e.qtd_coupon.toString())),
                qtd_item_coupon: e.qtd_item_coupon,
                volume: e.volume,
                year_actual: e.year_actual,
                year_avg_price: MoneyFullBRL(e.year_avg_price.toString()),
                year_billing: Number.parseFloat(e.year_billing.toString()),
                year_billing_label: MoneyLessBRL(e.year_billing.toString()),
                year_date: Moment(e.year_date).format('MM/YYYY'),
                year_volume:  Number(NumberLessBRL(e.year_volume.toString())),
            };
            mappedData.push(item);

        });

        return mappedData;
    }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/month-comparative/PublisherMonthComparative.tsx